import { render, staticRenderFns } from "./web-editor.vue?vue&type=template&id=5b367ce3&scoped=true"
import script from "./web-editor.vue?vue&type=script&lang=js"
export * from "./web-editor.vue?vue&type=script&lang=js"
import style0 from "./web-editor.vue?vue&type=style&index=0&id=5b367ce3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b367ce3",
  null
  
)

export default component.exports